/* global axios */

import ApiClient from './ApiClient';

// Canned responses are sent as multipart so attachments can travel with the record.
// Rails reads canned_response[...] identically whether it arrives as JSON or form data.
const buildFormData = ({
  short_code: shortCode,
  content,
  attachments = [],
}) => {
  const formData = new FormData();
  formData.append('canned_response[short_code]', shortCode);
  formData.append('canned_response[content]', content);
  attachments.forEach(entry => {
    // A library pick is already in storage, so its signed id goes over the wire and the
    // server attaches that same blob instead of keeping a second copy of the file.
    formData.append(
      'canned_response[attachments][]',
      entry instanceof File ? entry : entry.signed_id
    );
  });
  return formData;
};

class CannedResponse extends ApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  get({ searchKey }) {
    const url = searchKey ? `${this.url}?search=${searchKey}` : this.url;
    return axios.get(url);
  }

  create(data) {
    return axios.post(this.url, buildFormData(data));
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, buildFormData(data));
  }

  destroyAttachment(id, attachmentId) {
    return axios.delete(`${this.url}/${id}/attachments/${attachmentId}`);
  }

  // Files already attached to other canned responses, for reuse without re-uploading.
  library() {
    return axios.get(`${this.url}/library`);
  }
}

export default new CannedResponse();
